/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { searchTracker } from '../../actions/universalTracker';
import SearchComponent from './SearchComponent';
import { Suggestion, UTRSuggestion } from '@g17eco/types/search';
import { UtrValueType } from '@g17eco/types/universalTracker';

const renderSuggestion = (suggestion: Partial<UTRSuggestion>) => {
  return (
    <div className='suggestion-item'>
      <span>
        <div>{suggestion.name}</div>
      </span>
    </div>
  );
}

interface UTRSearchProps {
  placeholder: string;
  handleValueChange: (searchStr: string, currentSuggestion?: UTRSuggestion) => void;
  inputClassName?: string;
  filter?: {
    valueType: UtrValueType[]
  };
  initiativeId?: string;
}

export const UTRSearch = (props: UTRSearchProps) => {
  const valueChange = (searchStr: string, currentSuggestion?: Suggestion) => props.handleValueChange(searchStr, currentSuggestion as UTRSuggestion);

  return (
    <SearchComponent
      {...props}
      handleValueChange={valueChange}
      searchAction={(search) => searchTracker(search, props.filter, props.initiativeId)}
      renderSuggestion={renderSuggestion}
    />
  );
}

export default UTRSearch;
